import {useDetectClickOutside} from 'react-detect-click-outside';
import {useEffect} from 'react';

function ContextMenu({anchorPoint, close, menu, position, setHeight }) {

	console.log(position)

	const closeContextMenu = () => {
		close(false)
	}
	const ref = useDetectClickOutside({
		onTriggered: closeContextMenu
	});
	useEffect(() => setHeight(ref.current.offsetHeight), [])
	return (
		<div ref={ref} style={{top: anchorPoint.y, left: anchorPoint.x}}
		     className={`context-menu w-44 rounded absolute z-10 bg-gray-810 shadow-spotify-shadow text-black ${position.x === 'left' ? '-translate-x-full' : ''} ${position.y === 'top' ? '-translate-y-full' : ''}`}>
			{menu.map((menus, key) => (
				<ul key={key} className="p-1 border-b border-white border-opacity-5 last:border-none">
					{menus.map((item, index) => (
						<li key={index}>
							<button
								className="h-10 text-left flex w-full rounded-sm items-center justify-start text-white text-opacity-80 px-4 hover:bg-white hover:bg-opacity-10" style={{fontSize: '13px'}}>
								{item.title}
							</button>
						</li>
					))}
				</ul>
			))}
		</div>
	)
}

export default ContextMenu